<script setup lang="ts" generic="DataT, FooterDataT">
import { computed } from 'vue'
import type { Table } from '../../../../types'

interface Props {
  cell: Table.Cell<DataT> | Table.BodyCell<DataT> | Table.FooterCell<FooterDataT, DataT>
  index: number
  data?: DataT | FooterDataT
  cellClassname?: Record<string, boolean> | string | string[]
}

const props = defineProps<Props>()

const allowHtml = computed<boolean>(() => 'allowHtml' in props.cell ? props.cell?.allowHtml ?? false : false)

const compiledContent = computed<string | number | undefined>(() => {
  if (typeof props.cell.content === 'function') {
    return props.cell.content(props.data, props.index)
  }

  return props.cell.content
})
</script>

<template>
  <td>
    <slot
      name="default"
      :cell-classname="cellClassname"
      :content="compiledContent"
    >
      <span
        v-if="allowHtml"
        :class="cellClassname"
        v-html="compiledContent"
      />
      <span
        v-else
        :class="cellClassname"
      >{{ compiledContent }}</span>
    </slot>
  </td>
</template>
